import {
  ApiDatafanAccountCredential,
  IApiDatafanCredentialMeta,
} from "@smp/api";
import { useQuery, UseQueryOptions } from "react-query";

import { useQueryDatafanProject } from "@/queries/datafan/use_query_datafan_project";

const KEY = "datafan.credential.meta";

type IParams = Omit<
  Parameters<typeof ApiDatafanAccountCredential.Meta.get>[0],
  "project_id"
>;

export const useQueryDatafanCredentialMeta = <TParams extends IParams>(
  { accountCredentialId, object, extraParams }: TParams,
  options?: Omit<
    UseQueryOptions<IApiDatafanCredentialMeta[TParams["object"]]>,
    "queryKey" | "queryFn"
  >,
) => {
  const {
    data: project,
    error: projectError,
    isLoading: projectIsLoading,
  } = useQueryDatafanProject({
    enabled: options?.enabled,
  });

  const { data, error, isLoading } = useQuery<
    IApiDatafanCredentialMeta[TParams["object"]]
  >(
    [KEY, accountCredentialId, object, project?.id],
    () =>
      ApiDatafanAccountCredential.Meta.get<TParams["object"]>({
        accountCredentialId,
        extraParams,
        object,
        project_id: project?.id || 0,
      }),
    {
      ...options,
      enabled: !!project && options?.enabled,
    },
  );

  return {
    data,
    error: error || projectError,
    isLoading: isLoading || projectIsLoading,
  };
};

useQueryDatafanCredentialMeta.KEY = KEY;
